import React from 'react'

import {Link} from 'gatsby'

import {
    EuiText,
    EuiCallOut
  } from '@elastic/eui'

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="alert" title="Smarthome Integration:">
        <EuiText>
          <ul>
              <li><Link to="/Software/Windows/Blue_Iris_v5/INSTAR_MQTT/">BlueIris and INSTAR MQTT</Link></li>
              <li><Link to="/Software/Windows/Blue_Iris_v5/Node-RED/">BlueIris and Node-RED</Link></li>
              <li><Link to="/Software/Windows/Blue_Iris_v5/ioBroker/">BlueIris and ioBroker</Link></li>
              <li><Link to="/Software/Windows/Blue_Iris_v5/Home_Assistant/">BlueIris and Home Assistant</Link></li>
              <li><Link to="/Frequently_Asked_Question/BlueIris_v5_preset_positions/">BlueIris Preset Positions</Link></li>
              <li><Link to="/Frequently_Asked_Question/BlueIris_v5_http_alarmserver/">BlueIris as HTTP Alarmserver</Link></li>
          </ul>
        </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox

